import React, { Component } from "react";
import { Helmet } from "react-helmet-async";
import SliderSec from "./SliderSec/SliderSec";
import PopularTest from "./PopularTest/PopularTest";
import Certification from "./Certification/Certification";
import FAQSection from "./FAQSection/FAQSection";

class Home extends Component {
  render() {
    return (
      <>
        <Helmet>
          {/* ===== PRIMARY SEO TITLE ===== */}
          <title>
            Best Diagnostic Centre in Mohali | NABL Certified Lab – Kior Healthcare
          </title>

          {/* ===== META DESCRIPTION (AI + GOOGLE) ===== */}
          <meta
            name="description"
            content="Looking for a trusted diagnostic centre in Mohali? NABL certified lab offering accurate reports, blood tests & pathology services across Tricity."
          />

          {/* ===== SEARCH ENGINE DIRECTIVES ===== */}
          <meta name="robots" content="index, follow" />
          <meta name="googlebot" content="index, follow" />

          {/* ===== OPEN GRAPH (AI + SOCIAL) ===== */}
          <meta
            property="og:title"
            content="Best Diagnostic Centre in Mohali, Punjab | Kior Healthcare"
          />
          <meta
            property="og:description"
            content="Visit Kior Healthcare, the best diagnostic centre in Mohali, Punjab. Book MRI, CT Scan, X-Ray, Ultrasound, and blood tests with advanced technology and accurate reports. Serving Chandigarh, Panchkula, and Tricity. Book your test today."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://kiorhealthcare.com/" />
          <meta
            property="og:image"
            content="https://kiorhealthcare.com/og-image.jpg"
          />

          {/* ===== STRUCTURED DATA (AIO BOOST) ===== */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              name: "Kior Healthcare",
              url: "https://kiorhealthcare.com",
              logo: "https://kiorhealthcare.com/logo.png",
              address: {
                "@type": "PostalAddress",
                addressRegion: "Punjab",
                addressCountry: "IN",
              },
              medicalSpecialty: ["Diagnostic Radiology", "Pathology"],
              areaServed: {
                "@type": "State",
                name: "Punjab",
              },
            })}
          </script>
        </Helmet>

        {/* ===== PAGE CONTENT ===== */}
        <SliderSec />
        <PopularTest />
        <FAQSection />
        <Certification />
      </>
    );
  }
}

export default Home;
